import axios from 'axios';
import Account from '../models/Account';
import request from '../shared/http';
import API_CONFIG from '../config/api.config';
import { persistAuthTokenFromResponse } from '../shared/authToken';

const cache = {};

function w1Url(path) {
  const base = String(API_CONFIG.BASE_URL || '').replace(/\/$/, '');
  return `${base}/w1${path.startsWith('/') ? path : `/${path}`}`;
}

function w1ErrorMessage(status, data) {
  if (!data) return `Request failed (${status})`;
  if (typeof data.error === 'string') return data.error;
  if (data.error && typeof data.error === 'object' && data.error.message) {
    return String(data.error.message);
  }
  return `Request failed (${status})`;
}

class AuthService {
  getURL() {
    return '/accounts/@me';
  }

  async authenticate(id, password) {
    await request.post('/authenticate', {
      username: id,
      password,
    });
  }

  async createAccount({
    firstName,
    lastName,
    mobile,
    password,
    mobileVerificationId,
    mobileVerificationCode,
  }) {
    const domain = API_CONFIG.BASE_URL;
  const url = `${domain}/signup`;
  const payload = new URLSearchParams();
  payload.append('first_name', firstName);
  payload.append('last_name', lastName);
  payload.append('mobile', mobile);
  payload.append('password', password);
  payload.append('mobile_verification_id', mobileVerificationId);
  payload.append('mobile_verification_code', mobileVerificationCode);
  payload.append('type', 'user');
   const response = await axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
    withCredentials: true,
  });
    persistAuthTokenFromResponse(response.data);
    cache.account = new Account({
      firstName,
      lastName,
    });
    return response;
  }

  async UpdateAccount({
    mobile,
    mobileVerificationCode,
    mobileVerificationId,
  }) {
    // const url = "/accounts/@me";
    const response = await request.put(this.getURL(), {
      mobile,
      mobile_verifiaction_id: mobileVerificationId,
      mobile_verification_code: mobileVerificationCode,
    });
    return response;
  }

  async createEmailVerificationCode(mobile) {
    const response = await axios({
      method: 'POST',
      url: '/w1/auth/verification',
      data: { login_id: mobile.trim() },
    });
    return response.data.data.id;
  }

  async signupVerificationCode( mobile, firstName) {
    const payload = {};

    if (mobile) {
      payload.login_mobile = mobile.trim();
    }
    if (firstName) {
      payload.first_name = firstName;
    }
    const url = '/auth/userverification';
    const { data } = await request.post(url, payload)
    return data;
  }

  async googleSignupVerificationCode(mobile) {
    const response = await axios({
      method: 'POST',
      url: '/w1/auth/userverification',
      data: { login_mobile: mobile },
    });
    return response.data.data.id;
  }

  async requestPasswordReset(loginId) {
    const res = await axios.post(
      w1Url('/auth/password-reset/request'),
      { login_id: String(loginId || '').trim() },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        validateStatus: () => true,
      },
    );
    if (res.status !== 201) {
      throw new Error(w1ErrorMessage(res.status, res.data));
    }
    const id = res.data?.data?.verification_id ?? res.data?.data?.id;
    if (!id) {
      throw new Error('Unexpected response: missing verification id');
    }
    return id;
  }

  async resetPassword({
    verificationId, verificationCode, loginId, password,
  }) {
    const payload = {
      verification_id: verificationId,
      verification_code: verificationCode,
      login_id: loginId,
      password,
    };
    const res = await axios.post(w1Url('/auth/reset-password'), payload, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      validateStatus: () => true,
    });
    if (res.status !== 204) {
      throw new Error(w1ErrorMessage(res.status, res.data));
    }
    return true;
  }

  async sendLoginOtp(loginId) {
    const res = await axios.post(
      w1Url('/auth/login-verification'),
      { login_id: String(loginId || '').trim() },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        validateStatus: () => true,
      },
    );
    if (res.status !== 201) {
      throw new Error(w1ErrorMessage(res.status, res.data));
    }
    return res.data?.data?.id;
  }

  async signInWithOtp({
    loginId, verificationId, verificationCode,
  }) {
    const base = String(API_CONFIG.BASE_URL || '').replace(/\/$/, '');
    const res = await axios.post(
      `${base}/signin/otp`,
      {
        login_id: String(loginId || '').trim(),
        verification_id: verificationId,
        verification_code: verificationCode,
        type: 'user',
      },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        validateStatus: () => true,
      },
    );
    if (res.status !== 200) {
      throw new Error(w1ErrorMessage(res.status, res.data));
    }
    persistAuthTokenFromResponse(res.data);
    return res.data;
  }
}

export default new AuthService();
